module.exports = __webpack_public_path__ + "static/google-play-badge-dcd97e03cca046aa53b1b27d814241ed.png";